import { HtmlId } from '../enums/elementId';
import {
    Accordion,
    createAccordion,
} from '@vfde-brix/ws10/accordion';
import { mountComponent } from '../util/mount';
import {
    getFootnoteHeadlineMapper,
    getFootnoteContentMapper,
    getFootnoteCmsContent,
} from '../util/components/footnoteHelper';
import { replaceAllPlaceholders } from '../util/formatter';
import { trackAccordion } from '../util/tracking';
import { setFiberProperty } from '../util/cms';
import { mountFootnoteLinks } from './footnoteLink';
import { addDisplayMetacodeToFootnote } from '../util/displayMetacodes';
import { JarvisProduct } from '@vfde-sails/avc-core';

export enum AccordionType {
    FAQ = 'faq',
    Footnote = 'footnote',
    Comission = 'beauftragung',
    Connection = 'glasfaser-anschluss',
    Cost = 'kosten',
}

export const mountAccordion = (wrapperId: HtmlId, type: AccordionType) => {
    const accordion = mountComponent(wrapperId, createAccordion, {
        onToggle: ({ stdHeadline, optOpen }) => optOpen && trackAccordion(stdHeadline, type),
    });

    setFiberProperty(wrapperId, accordion);

    return accordion;
};

export const closeAccordionItems = (accordion: Accordion) => {
    const { items } = accordion.getProperties();
    for (const item of items) {
        item.optOpen = false;
    }
    accordion.update({ items });
};

export const updateAccordionFootnote = (
    accordion: Accordion,
    tariffs: JarvisProduct[],
    selectedTariff?: JarvisProduct,
    regioCharge?: number,
    fiberAvailable?: boolean,
    enabled?: boolean,
) => {
    if (!accordion || !selectedTariff) {
        return;
    }

    const { items } = accordion.getProperties();
    const dynamicItem = items[0];
    const footnoteTexts = getFootnoteCmsContent();

    if (!dynamicItem || !footnoteTexts) {
        return;
    }

    items.forEach(item => {
        item.stdIconLeft = undefined;
    });

    // Note: Content of first item is dynamic, other items are optional and static!
    items[0] = {
        ...dynamicItem,
        stdHeadline: replaceAllPlaceholders(
            footnoteTexts.headline,
            getFootnoteHeadlineMapper(selectedTariff, regioCharge)
        ),
        containerAnyComponent: replaceAllPlaceholders(
            footnoteTexts.content,
            getFootnoteContentMapper(selectedTariff, tariffs, regioCharge)
        ),
    };

    accordion.update({ items });

    mountFootnoteLinks(tariffs, fiberAvailable && enabled);
    addDisplayMetacodeToFootnote(selectedTariff?.id || '');
};
